import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { JobfunctionCategory } from './job-function-category.interface';
import { JobFunctionCategoryService } from './job-function-category.service';

const service = new JobFunctionCategoryService();

export interface JobFunctionCategoryState {
   jobFunctionCategories: Array<JobfunctionCategory>;
}

const JobFunctionCategoryStore: Module<JobFunctionCategoryState, StoreState> = {
   namespaced: true,
   state: {
      jobFunctionCategories: [],
   },
   getters: {},
   mutations: {
      SET_JOB_FUNCTION_CATEGORIES(state, jobFunctionCategories: Array<JobfunctionCategory>) {
         state.jobFunctionCategories = jobFunctionCategories;
      },
   },
   actions: {
      async getJobFunctionCategories({ commit }) {
         const jobFunctionCategories = await service.getJobFunctionCategories();
         commit('SET_JOB_FUNCTION_CATEGORIES', jobFunctionCategories.data);
         return jobFunctionCategories.data;
      },
   },
};

export default JobFunctionCategoryStore;
